import React from "react";

const LoaderDashboard = () => {
  return (
    <div className="h-screen">
      <div className="flex flex-row w-full">
        <div className="w-[400px] h-screen bg-gray-100">
          <div className="grid grid-cols-1 gap-10 p-5">
            <div className="w-full h-[160px]  animate-pulse rounded bg-gray-200"></div>
           
            <div className="h-4 w-full animate-pulse rounded bg-gray-200"></div>
              <div className="h-4 w-32 animate-pulse rounded bg-gray-200"></div>
              <div className="h-4 w-56 animate-pulse rounded bg-gray-200"></div>
              <div className="h-4 w-56 animate-pulse rounded bg-gray-200"></div>
              <div className="h-4 w-20 animate-pulse rounded bg-gray-200"></div> 
              <div className="h-4 w-full animate-pulse rounded bg-gray-200"></div>
              <div className="h-4 w-full animate-pulse rounded bg-gray-200"></div>
              <div className="h-4 w-16 animate-pulse rounded bg-gray-200"></div>

              <div className="h-4 w-full animate-pulse rounded bg-gray-200"></div>
              <div className="h-4 w-full animate-pulse rounded bg-gray-200"></div>
          </div>
          
        </div>
        <div className="w-full h-screen flex flex-col gap-5 m-5">
             <div className="grid grid-cols-5 gap-5 w-full">
             <div className="w-full h-20  animate-pulse rounded bg-gray-200"></div>
             <div className="w-full h-20  animate-pulse rounded bg-gray-200"></div>
             <div className="w-full h-20  animate-pulse rounded bg-gray-200"></div>
             <div className="w-full h-20  animate-pulse rounded bg-gray-200"></div>
             <div className="w-full h-20  animate-pulse rounded bg-gray-200"></div>

             </div>
             <div className="grid grid-cols-1 gap-5 w-full">
             <div className="w-[80%] h-4  animate-pulse rounded bg-gray-200"></div>
             <div className="w-[60% h-4  animate-pulse rounded bg-gray-200"></div>
             <div className="w-[70%] h-4  animate-pulse rounded bg-gray-200"></div>
  

             </div>
             <div className="grid grid-cols-1 gap-5 w-full mt-20">
             <div className="w-[80%] h-4  animate-pulse rounded bg-gray-200"></div>
             <div className="w-[60% h-4  animate-pulse rounded bg-gray-200"></div>
             <div className="w-[70%] h-4  animate-pulse rounded bg-gray-200"></div>
  

             </div>
             <div className="grid grid-cols-1 gap-5 w-full mt-20">
             <div className="w-[80%] h-4  animate-pulse rounded bg-gray-200"></div>
             <div className="w-[60% h-4  animate-pulse rounded bg-gray-200"></div>
             <div className="w-[70%] h-4  animate-pulse rounded bg-gray-200"></div>
  

             </div>
       
          </div>
      </div>
    </div>
  );
};

export default LoaderDashboard;
